import {encrypt} from "./simpleEncrypt"

const generatePublicClientToken = (apiKey, offset, secret) => {
  return encrypt(secret, "a2xhcgAAAAAAAAAA", `${apiKey}||${offset}`)
}

export { generatePublicClientToken }
